var _excluded = ["readableName", "after", "before", "iconsStyle", "validated", "errorFields", "setErrorFields", "isErrorVisible", "fieldPosition", "name", "currentRef", "value", "defaultValue", "onChange", "maybeErrorMessage", "error", "onSearch"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*eslint-disable react-hooks/exhaustive-deps*/
import React, { Fragment, useState, useEffect } from 'react';
import { mergeClasses } from '../../classify';
import { FieldIcons, Message } from '../Field';
import defaultClasses from './textInput.css';
import { useIntl } from 'react-intl';
var TextInput = props => {
  var {
      // comes from Field component (same as label prop)
      readableName,
      after,
      before,
      iconsStyle,
      validated,
      errorFields,
      setErrorFields,
      isErrorVisible,
      fieldPosition,
      name,
      currentRef,
      value: directValue,
      defaultValue,
      onChange: propsOnChange,
      maybeErrorMessage,
      error: initialError,
      onSearch
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var [error, setError] = useState('');
  var [currentValue, setCurrentValue] = useState(defaultValue || '');
  var [alreadyPassedValidation, setAlreadyPassedValidation] = useState(false);
  var {
    formatMessage
  } = useIntl();
  var classes = mergeClasses(defaultClasses, props.classes);
  useEffect(() => {
    setCurrentValue(defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    if (errorFields) {
      var errMessage = '';
      if (validated) {
        errMessage = validated(directValue || currentValue);
        setAlreadyPassedValidation(!errMessage);

        //will display error message
        if (isErrorVisible || alreadyPassedValidation) {
          setError(errMessage && formatMessage(errMessage));
        }
      } else if (maybeErrorMessage || maybeErrorMessage === '') {
        errMessage = maybeErrorMessage;
        //will display error message
        if (isErrorVisible) {
          setError(maybeErrorMessage);
        }
      }
      var indexExist = errorFields.length ? errorFields.findIndex(el => el.fieldName === name && el.fieldPosition === fieldPosition) : null;

      // if there is arr error that is not saved yet, log it as new error to the errors array
      // if there is no more error on the field that had logged error, remove it from errors array
      // NOTICE: we are required to create a new copy of the array because we want rerender ( to not want to keep same reference in memory )
      // NOTICE 2: very important to .push and .slice on the referenced value to avoid race conditions
      if (errMessage && (indexExist === null || indexExist === undefined || indexExist < 0)) {
        var errObj = {
          fieldName: name,
          fieldPosition,
          readableName,
          message: errMessage,
          erroredValue: currentValue
        };
        errorFields.push(errObj);
        var errorArrCopy = [...errorFields];
        setErrorFields(errorArrCopy);
      } else if (!errMessage && indexExist !== null && indexExist !== undefined && indexExist >= 0) {
        errorFields.splice(indexExist, 1);
        var _errorArrCopy = [...errorFields];
        setErrorFields(_errorArrCopy);
      }
    }
    //PLEASE DO NOT CHANGE THE DEPENDENCIES EVEN IF ESLINT
    //IT SHOULD ALWAYS BE WHAT IT IS
  }, [currentValue, maybeErrorMessage, directValue, defaultValue, isErrorVisible, alreadyPassedValidation]);
  var inputClass = error ? classes.input_error : classes.input;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FieldIcons, {
    after: after,
    before: before,
    styles: iconsStyle,
    onSearch: onSearch
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    key: fieldPosition + '-' + name + '-input',
    name: name,
    className: inputClass,
    ref: currentRef,
    value: directValue || currentValue,
    onChange: e => {
      setCurrentValue(e.target.value);
      if (propsOnChange) {
        propsOnChange(e);
      }
    }
  }))), /*#__PURE__*/React.createElement(Message, null, initialError || error));
};
export default TextInput;